import { add, listen, qs } from "@fluorescent/dom";

import pageTransition from "@/js/lib/page-transition";
import modal from "@/js/lib/modal";
import storeAvailabilityDrawer from "@/js/lib/store-availability-drawer";
import { handleTab } from "@/js/lib/a11y";
import sectionClasses from "@/js/lib/section-classes";
import quickViewModal from "@/js/lib/quick-view-modal";
import productLightbox from "@/js/lib/product-lightbox";

import { flashAlertModal } from "@/js/lib/flash-alert";
import headerOverlay from "@/js/lib/header-overlay";
import backToTop from "@/js/lib/back-to-top";

// Detect theme editor
if (window.Shopify.designMode === true) {
  add(document.documentElement, "theme-editor");
  document.documentElement.classList.add("theme-editor");
} else {
  const el = qs(".theme-editor-scroll-offset", document);
  el && el.parentNode.removeChild(el);
}

// Page transitions
pageTransition();

// a11y tab handler
handleTab();

// Apply contrast classes
sectionClasses();

// Load productlightbox
productLightbox();

// Quick view modal
const quickViewModalElement = qs("[data-quick-view-modal]", document);

if (quickViewModalElement) {
  quickViewModal(quickViewModalElement);
}

// Setup modal
const modalElement = qs("[data-modal]", document);
modal(modalElement);

const flashModal = qs("[data-flash-alert]", document);
flashAlertModal(flashModal);

// Product availabilty drawer
const availabilityDrawer = qs("[data-store-availability-drawer]", document);
storeAvailabilityDrawer(availabilityDrawer);

// Setup header overlay
const headerOverlayContainer = document.querySelector("[data-header-overlay]");
headerOverlay(headerOverlayContainer);

// Init back to top button
backToTop();